export default __webpack_public_path__ + "static/media/learn.c41ecf85.png";